module.exports = __webpack_public_path__ + "static/media/400057_02.e2ae53af.png";